/*******************************************************
 * +MAP SERVICE
 *******************************************************/

"use strict";

/**
 * Module SERVICES
 */
angular.module("services")


	.factory("MapService", ["CONSTANTS", "ENV", "$http", function (CONSTANTS, ENV, $http) {

		var defaultMarkerStyle = {
			externalGraphic: CONSTANTS.MAP_MARKER_DEFAULT,
			graphicWidth: 20, graphicHeight: 32,
			pointRadius: 3,
			cursor: "pointer",
			graphicYOffset: -32
		};

		var commercialPointMarkerStyle = {
			externalGraphic: CONSTANTS.MAP_MARKER_END,
			graphicWidth: 20, graphicHeight: 32,
			pointRadius: 3,
			cursor: "pointer",
			graphicYOffset: -24
		};

		var highlightMarkerStyle = {
			externalGraphic: "assets/img/map_icons/pin-yellow.png",
			graphicWidth: 25, graphicHeight: 40,
			pointRadius: 3,
			cursor: "pointer",
			graphicYOffset: -40
		};

		var draggableMarkerStyle = {
			externalGraphic: "assets/img/map_icons/pin-green.png",
			graphicWidth: 25, graphicHeight: 40,
			pointRadius: 3,
			cursor: "pointer",
			graphicYOffset: -40
		};

		var mapBearingHandler;
		var mapBearingControl;
		var mapBearingHandlerLayerName;

		// PUBLIC API
		return {

			DEFAULT_TRACE_LAYER_NAME: "mapDefaultTraceLayerName",
			DEFAULT_POINTS_LAYER_NAME: "mapDefaultPointsLayerName",
			DEFAULT_DRAGGABLE_POINTS_LAYER_NAME: "mapDefaultDraggablePointsLayerName",

			showStartEndPoints: showStartEndPoints,
			computeFeatureBearing: computeFeatureBearing,
			computeBearing: computeBearing,
			showBearingHelp: showBearingHelp,
			hideBearingHelp: hideBearingHelp,

			addListenerToMap: addListenerToMap,
			removeListenerFromMap: removeListenerFromMap,

			getCoordinatesFromMapEvent: getCoordinatesFromMapEvent,
			getCoordinatesFromDraggedFeature: getCoordinatesFromDraggedFeature,
			getLocation: getLocation,

			prepareStopPointsTrace: prepareStopPointsTrace,

			addPointToMap: addPointToMap,

			removePointFromMap: removePointFromMap,

			drawSimplePoint: drawSimplePoint,

			displayRouteMap: displayRouteMap,

			prepareNetworkTrace: prepareNetworkTrace,

			prepareRouteStopPointsTrace: prepareRouteStopPointsTrace,

			drawPath: drawPath,

			drawPathWithPoints: drawPathWithPoints,

			clearLayer: clearLayer,

			closeAllPopups: closeAllPopups,

			clearMapUserLayers: clearMapUserLayers,

			addGeoPointsToPointsTable: addGeoPointsToPointsTable,

			featureTemplates: {
				routeStopPoint: popupRouteStopPointTemplate,
				stopPoint: popupPointsStopPointTemplate
			},

			markerStyles: {
				default: defaultMarkerStyle,
				highlight: highlightMarkerStyle
			}

		};

		function showStartEndPoints(map, startPoint, endPoint) {
			// show start and end markers
			var styleDefStart = angular.copy(defaultMarkerStyle);
			styleDefStart.externalGraphic = CONSTANTS.MAP_MARKER_START;

			var styleDefEnd = angular.copy(defaultMarkerStyle);
			styleDefEnd.externalGraphic = CONSTANTS.MAP_MARKER_END;

			clearLayer(map, CONSTANTS.MAP_LAYER_START_AND_STOP_POINT);

			addPointToMap(map, CONSTANTS.MAP_LAYER_START_AND_STOP_POINT, startPoint, styleDefStart, null, false);
			addPointToMap(map, CONSTANTS.MAP_LAYER_START_AND_STOP_POINT, endPoint, styleDefEnd, null, false);
		}

		function computeFeatureBearing(feature) {
			var drawnLinePoints = feature.geometry.getVertices();
			var lonlat1 = drawnLinePoints[0].transform(CONSTANTS.MAP_TO_PROJECTION, CONSTANTS.MAP_FROM_PROJECTION);
			var lonlat2 = drawnLinePoints[1].transform(CONSTANTS.MAP_TO_PROJECTION, CONSTANTS.MAP_FROM_PROJECTION);
			return computeBearing(lonlat1.y, lonlat1.x, lonlat2.y, lonlat2.x);
		}


		/**
		 * Crée un control open layers permettant de tracer un vecteur pour calculer le cap.
		 * Dessine le premier point du vecteur à partir des coordonnées fournies.
		 * @param map la carte sur laquelle dessiner
		 * @param long longitude du point à partir duquel tracer le vecteur cap
		 * @param lat latitude du point à partir duquel tracer le vecteur cap
		 * @param bearingCallback la fonction à appeler lorsque le deuxième point est cliqué.
		 */
		function showBearingHelp(map, long, lat, bearingCallback) {

			// Créer un control pour dessiner le cap
			var lineLayer = findOrCreateLayer(map, CONSTANTS.MAP_LAYER_BEARING, null, {});
			mapBearingControl = new OpenLayers.Control.DrawFeature(
				lineLayer,
				OpenLayers.Handler.Path, {
					handlerOptions: {
						maxVertices: 2, freehandMode: function (evt) {
							return false;
						}
					},
					featureAdded: function (feature) {
						bearingCallback(feature);
					}
				});
			map.addControl(mapBearingControl);
			mapBearingControl.activate();

			// Récupérer le handler associé au control et l'assigner à un objet global au service.
			mapBearingHandler = mapBearingControl.handler;
			mapBearingHandlerLayerName = mapBearingControl.handler.layer.name;

			// Dessiner le premier point du vecteur permettant de tracer le cap
			// à partir du stop point
			if (mapBearingHandler) {
				var pix = map.getPixelFromLonLat(new OpenLayers.LonLat(long, lat).transform(CONSTANTS.MAP_FROM_PROJECTION, CONSTANTS.MAP_TO_PROJECTION));
				mapBearingHandler.modifyFeature(pix, true);
				mapBearingHandler.addPoint(pix);
			}
		}

		function hideBearingHelp(map) {
			map.removeControl(mapBearingControl);
			mapBearingHandler.destroy();
			clearLayer(map, CONSTANTS.MAP_LAYER_BEARING);
			clearLayer(map, mapBearingHandlerLayerName);
		}


		/**
		 * Compute bearing. Careful, first point (the stop point) is the END point : we want to compute the bearing as if we were getting TO the bus stop and not leaving.
		 *
		 * @param endLat Stop point lat
		 * @param endLong Stop point long
		 * @param startLat clicked point lat
		 * @param startLong clicked point long
		 * @returns {number} The bearing in degrees.
		 */
		function computeBearing(endLat, endLong, startLat, startLong) {
			startLat = radians(startLat);
			startLong = radians(startLong);
			endLat = radians(endLat);
			endLong = radians(endLong);

			var dLong = endLong - startLong;

			var dPhi = Math.log(Math.tan(endLat / 2.0 + Math.PI / 4.0) / Math.tan(startLat / 2.0 + Math.PI / 4.0));
			if (Math.abs(dLong) > Math.PI) {
				if (dLong > 0.0)
					dLong = -(2.0 * Math.PI - dLong);
				else
					dLong = (2.0 * Math.PI + dLong);
			}

			return Math.floor((degrees(Math.atan2(dLong, dPhi)) + 360.0) % 360.0);
		}


		function getCoordinatesFromMapEvent(map, evt) {
			var lonlat = map.getLonLatFromViewPortPx(evt.xy);
			lonlat.transform(CONSTANTS.MAP_TO_PROJECTION, CONSTANTS.MAP_FROM_PROJECTION);
			return lonlat;
		}

		function getCoordinatesFromDraggedFeature(feature) {
			var lonlat = new OpenLayers.LonLat(feature.geometry.x, feature.geometry.y);
			lonlat.transform(CONSTANTS.MAP_TO_PROJECTION, CONSTANTS.MAP_FROM_PROJECTION);
			return lonlat;
		}


		function addListenerToMap(map, eventType, callbackFunction) {
			map.events.register(eventType, map, callbackFunction);
		}

		function removeListenerFromMap(map, eventType, callbackFunction) {
			map.events.unregister(eventType, map, callbackFunction);
		}

		function getLocation(callBackFunction) {
			return navigator.geolocation.getCurrentPosition(callBackFunction);
			// TODO : fallback for old browser ?
		}


		function prepareStopPointsTrace(data) {

			var tracesList = [];
			var editedStopPoint;
			var addMode = false;
			// Tells if the drawing of all the points should make a global zoom to see all the stop points or not.
			var shouldZoom = true;

			// if there's a stop point selected, style it and center map onto it.
			// default style for all other points
			if (data.currentStopPoint) {
				for (var i = 0; i < data.stopPoints.length; i++) {
					var stopPoint = data.stopPoints[i];
					if (stopPoint.id === data.currentStopPoint.id) {
						editedStopPoint = angular.copy(stopPoint);
						stopPoint.style = highlightMarkerStyle;
					} else {
						stopPoint.style = defaultMarkerStyle;
					}
				}
				// When a point is selected, we don't want to zoom on all the point
				if ( !data.zoom ) shouldZoom = false;

				// id no ID yet, then we're adding a point
				if (!data.currentStopPoint.id) {
					editedStopPoint = data.currentStopPoint;
					addMode = true;
				}

			}

			addGeoPointsToPointsTable(data.stopPoints);

			// Regular stop points, including current selected point
			if (data.stopPoints.length) {
				var stopPointsList = {
					id: "stopPoints",
					stopPoints: data.stopPoints,
					drawPath: false,
					drawPoints: true,
					zoomWhenDone: shouldZoom,
					clickFunction: data.stopPointSelectedCallbackFunction
				};
				tracesList.push(stopPointsList);
			}

			// Indicates if a current point is selected
			var isCurrentStopPointSelected = data.currentStopPoint && data.currentStopPoint.id;
			// Only center the map around the selected point when we are in searchMode or editMode
			if (data.searchMode || data.editMode) {
				if(isCurrentStopPointSelected) {
					data.stopPoints.find(function (point) {
						return point.id === data.currentStopPoint.id;
					}).center = true;
				}
			} else {
				// Reset all center property for each point
				data.stopPoints.forEach(function (point) {
					point.center = false;
				});
			}

			if (data.editMode) {
				if (isCurrentStopPointSelected || addMode) {
					// Special layer with currently edited point - draggable
					editedStopPoint.style = draggableMarkerStyle;
					var editedStopPointList = {
						id: "editedStopPoints",
						stopPoints: [editedStopPoint],
						drawPath: false,
						drawPoints: true,
						zoomWhenDone: data.zoom,
						draggable: true,
						draggableFeatureCallbackFunction: data.draggableFeatureCallbackFunction
					};
					tracesList.push(editedStopPointList);
				}

				// Another layer showing commercial points
				if (data.commercialPoints && data.commercialPoints.length) {
					data.commercialPoints.map(function (point) {
						point.style = commercialPointMarkerStyle;
					});
					var commercialPointsList = {
						id: "commercialPoints",
						stopPoints: data.commercialPoints,
						drawPath: false,
						zoomWhenDone: data.zoom,
						clickFunction: data.commercialPointSelectedCallbackFunction
					};
					tracesList.push(commercialPointsList);
				}
			}

			if (data.lines && data.lines.length) {
				data.lines.map(function (line) {
					tracesList.push(line);
				});
			}


			return tracesList;
		}


		function clearMapUserLayers(map) {
			closeAllPopups(map);
			var layersName = map.layers.map(function (layer) {
				return layer.name;
			});
			for (var i = 0; i < layersName.length; i++) {
				if ( ( layersName[i].indexOf("OpenStreetMap") <= -1) && ( layersName[i].indexOf("Satellite") <= -1 ) ) {
					clearLayer(map, layersName[i]);
				}
			}
		}


		/**
		 * Remove all features and listeners assocaited with a layer
		 * @param map
		 * @param layerName
		 */
		function clearLayer(map, layerName) {
			var layers = map.getLayersByName(layerName);
			if (layers.length) {

				layers[0].destroyFeatures();

				// remove listeners associated with this layer (ex: click events)
				for (var listenerName in  layers[0].events.listeners) {
					if (layers[0].events.listeners.hasOwnProperty(listenerName)) {
						layers[0].events.unregister(listenerName, layers[0], layers[0].events.listeners[listenerName][0].func);
					}
				}
				map.removeLayer(layers[0]);

			}
		}

		function closeAllPopups(map) {
			var pops = map.popups;
			for (var a = 0; a < pops.length; a++) {
				map.removePopup(map.popups[a]);
			}
		}


		/**
		 * Deletes a point from the map on the given layer.
		 * @param map
		 * @param layerName
		 * @param point
		 */
		function removePointFromMap(map, layerName, point) {
			var layer = findOrCreateLayer(map, layerName);
			layer.removeFeatures([layer.getFeatureById(point.featureId)]);
		}

		/**
		 * Draws a marker on the map given its coordinates.
		 * Returns the newly created feature id for reference.
		 * @param map
		 * @param latitude
		 * @param longitude
		 * @returns {number}
		 */
		function drawSimplePoint(map, latitude, longitude, customStyle, zoomWhenDone) {
			var layer = findOrCreateLayer(map, CONSTANTS.MAP_LAYER_SIMPLE, null, customStyle);
			var feature = new OpenLayers.Feature.Vector(
				new OpenLayers.Geometry.Point(
					longitude, latitude).transform(CONSTANTS.MAP_FROM_PROJECTION, CONSTANTS.MAP_TO_PROJECTION));
			layer.destroyFeatures();
			layer.addFeatures([feature]);
			if (zoomWhenDone) {
				map.zoomToExtent(layer.getDataExtent());
			}
			return feature.id;
		}

		/**
		 * Display route on map
		 * @param map dom element to draw map in
		 * @param routeData json route data
		 */
		function displayRouteMap(map, routeData) {
			// New layer for the whole route, or reuse existing
			var wholeRouteLayer;
			var layers = map.getLayersByName("Whole route layer");
			if (layers.length) {
				wholeRouteLayer = layers[0];
				wholeRouteLayer.destroyFeatures();
			} else {
				wholeRouteLayer = new OpenLayers.Layer.Vector("Whole route layer");
				map.addLayer(wholeRouteLayer);
				map.addControl(new OpenLayers.Control.DrawFeature(wholeRouteLayer, OpenLayers.Handler.Path));
			}

			// extract point from scope data, transorm it with the right coordinate system, and store them in an array
			var points = [];
			var dataPoints = routeData.points;
			for (var i = 0; i < dataPoints.length; i++) {
				points.push(new OpenLayers.Geometry.Point(dataPoints[i].longitude, dataPoints[i].latitude).transform(CONSTANTS.MAP_FROM_PROJECTION, CONSTANTS.MAP_TO_PROJECTION));
			}

			// Draw a line joining the points, and add it to the route layer
			var line = new OpenLayers.Geometry.LineString(points);
			var style = {
				strokeColor: "#0000ff",
				strokeOpacity: 0.5,
				strokeWidth: 5
			};
			var lineFeature = new OpenLayers.Feature.Vector(line, null, style);
			wholeRouteLayer.addFeatures([lineFeature]);
			map.zoomToExtent(wholeRouteLayer.getDataExtent());

		}

		/**
		 * Adds a simple point to the map on the given layer.
		 * @param map
		 * @param layerName
		 * @param point
		 * @returns {number}
		 */
		function addPointToMap(map, layerName, point, style, featurePopupTemplate, zoomWhenDone) {
			var layer = findOrCreateLayer(map, layerName, featurePopupTemplate);

			var newPoint = new OpenLayers.Geometry.Point(point.longitude, point.latitude).transform(CONSTANTS.MAP_FROM_PROJECTION, CONSTANTS.MAP_TO_PROJECTION);

			var feature  = new OpenLayers.Feature.Vector(
				newPoint,
				{
					point: point
				},
				style
			);
			layer.addFeatures([feature]);

			if (point.center) {
				map.setCenter(new OpenLayers.LonLat(point.longitude, point.latitude).transform(CONSTANTS.MAP_FROM_PROJECTION, CONSTANTS.MAP_TO_PROJECTION), 17);
			}

			if (zoomWhenDone) {
				map.zoomToExtent(layer.getDataExtent());
			}

			return feature;
		}


		/**
		 * Helper function that transform WS payload into a table of points ready to draw.
		 * @param payload
		 */
		function prepareNetworkTrace(payload) {
			var linesData = [];

			if (payload.lignes) {
				for (var i = 0; i < payload.lignes.length; i++) {
					var ligne = payload.lignes[i];
					if (ligne.itineraires && ligne.itineraires.length > 0) {

						//                        for (var j = 0; j < ligne.itineraires.length; j++) {
						var j = 0;// todo pour le moment on prend juste le premier itinéraire. A terme Okina doit renvoyer seulement la bonne liste de points de la ligne (chemin le plus long)
						var route = ligne.itineraires[j];

						if (route.trace_gps.length) {
							// GPS TRACE

						} else {
							// STOP POINTS
							addGeoPointsToPointsTable(route.sequence_arrets);
						}
						//                        }

						linesData.push({
							stopPoints: route.sequence_arrets,
							id: ligne.id,
							journeyPatternId: route.journeyPatternId,
							color: ligne.couleur, //'#' + Math.floor(Math.random() * 16777215).toString(16),
							drawPath: true,
							drawPoints: true,
							zoomWhenDone: true,
							showStartAndEndPoints: true,
							showPoints: true,
							showPath: true
						});
					}

				}
			}
			return linesData;
		}

		function prepareRouteStopPointsTrace(wsPayload) {

			addGeoPointsToPointsTable(wsPayload.stop_points);

			var routeInfos = {
				stopPoints: wsPayload.stop_points,
				id: wsPayload.id,
				journeyPatternId: wsPayload.id,
				color: CONSTANTS.MAP_ROUTE_COLOR, //'#' + Math.floor(Math.random() * 16777215).toString(16),
				drawPath: true,
				drawPoints: true,
				zoomWhenDone: true,
				showStartAndEndPoints: true
			};

			return [routeInfos];
		}

		function addGeoPointsToPointsTable(stopPoints) {
			// Add an ol point object with correct geo coordinates into ws array
			for (var i = 0; i < stopPoints.length; i++) {
				var stopPoint = stopPoints[i];
				var olPoint = transformGeometryAndCreateOlPoint([stopPoint.longitude, stopPoint.latitude]);
				stopPoint["geoPoint"] = olPoint;
			}
		}

		/**
		 * Draw a line on the given map, given layer, with given color.
		 * Returns the crated feature.
		 * Crates tje layer if it doesnt exist.
		 * @param map
		 * @param layerName
		 * @param routeId
		 * @param points
		 * @param pathPoints
		 * @param color
		 * @param zoomWhenDone
		 */
		function drawPath(map, layerName, routeId, points, pathPoints, color, zoomWhenDone) {

			// reuse existing layer or create one.
			var layer;
			var layers = map.getLayersByName(layerName);
			if (layers.length) {
				layer = layers[0];
			} else {
				layer = new OpenLayers.Layer.Vector(layerName);
				map.addLayer(layer);
				map.addControl(new OpenLayers.Control.DrawFeature(layer, OpenLayers.Handler.Path));
			}

			if (color == undefined) {
				color = "#FE0FE0";
			}

			$http.get(ENV.API_URL + "/exploitation/parcours/map-matching/" + routeId + "/export/GEOJSON").then(function (data) {
				var geojsonFormat = new OpenLayers.Format.GeoJSON({
					externalProjection: CONSTANTS.MAP_FROM_PROJECTION,
					internalProjection: CONSTANTS.MAP_TO_PROJECTION
				});
				var vector = geojsonFormat.read(data);
				vector[0].style = {
					strokeColor: color.startsWith("#") ? color : "#" + color,
					strokeOpacity: 0.8,
					strokeWeight: 5
				};
				layer.addFeatures(vector);
				if (zoomWhenDone) {
					map.zoomToExtent(layer.getDataExtent());
				}
			}).catch(function (data) {
				console.log(data);
				//toastr.warning("Map-matching du trajet indisponible.");
				// Draw a line joining the points, and add it to the route layer
				var line = new OpenLayers.Geometry.LineString(pathPoints);
				var style = {
					strokeColor: color.startsWith("#") ? color : "#" + color,
					strokeOpacity: 0.8,
					strokeWidth: 5
				};
				var lineFeature = new OpenLayers.Feature.Vector(line, null, style);
				layer.addFeatures([lineFeature]);
				if (zoomWhenDone) {
					map.zoomToExtent(layer.getDataExtent());
				}
			});

		}


		/**
		 * Draw a line on the given map, given layer, with given color.
		 * Draw stop points.
		 * Returns the crated feature.
		 * Crates tje layer if it doesnt exist.
		 * @param map
		 * @param routeId
		 * @param points
		 * @param color
		 * @param showPoints
		 * @param showPath
		 * @param options
		 */
		function drawPathWithPoints(map, routeId, points, color, showPoints, showPath, options) {

			var features = {
				path: {},
				points: []
			};

			// draw path
			if (options.drawPath && (showPath || showPath === undefined)) {
				var pathPoints = [];
				points.map(function (element) {
					pathPoints.push(element.geoPoint);
				});
				features.path = drawPath(map, this.DEFAULT_TRACE_LAYER_NAME, routeId, points, pathPoints, color, false);
			}

			// draw points
			if (options.drawPoints && (showPoints || showPoints === undefined)) {
				for (var i = 0; i < points.length; i++) {
					var point = points[i];
					var styleDef = preparePointsStyle(points, point, options, i);
					if (options.draggable) {
						// dragagble layer
						features.points[point.id + "draggable"] = addPointToMap(map, this.DEFAULT_DRAGGABLE_POINTS_LAYER_NAME, point, styleDef, options.featurePopupTemplate);
					} else {
						// regular layer
						features.points[point.id] = addPointToMap(map, this.DEFAULT_POINTS_LAYER_NAME, point, styleDef, options.featuresPopupTemplate);
					}
				}
			}

			// optional points clicked callback
			if (options.featuresCallBackFunction) {
				var pointsLayer = map.getLayersByName(this.DEFAULT_POINTS_LAYER_NAME)[0];
				pointsLayer.events.register("featureselected", pointsLayer, options.featuresCallBackFunction);
			}

			// optional draggable feature(s) points
			if (options.draggable) {
				var dragControl = new OpenLayers.Control.DragFeature(map.getLayersByName(this.DEFAULT_DRAGGABLE_POINTS_LAYER_NAME)[0], {
					"onDrag": function (feature) {
						//options.dragCallbackFunction
						options.draggableFeatureCallbackFunction(feature);
					}
				});
				map.addControl(dragControl);
				dragControl.activate();
			}


			if (options.zoomWhenDone) {
				var layersFound = map.getLayersByName(this.DEFAULT_POINTS_LAYER_NAME);
				if (layersFound.length) {
					map.zoomToExtent(layersFound[0].getDataExtent());
				}
			}

			return features;

		}


		/**
		 * Template for map marker's popups.
		 * @param feature feature properties to display.
		 * @returns {string}
		 */
		function popupCreateRouteTemplate(feature) {
			var liaisons = "";
			var liste = feature.attributes.point.liaisons;
			if (liste) {
				liaisons += "<br>Liaisons : <dt>";
				for (var i = 0; i < liste.length; i++) {
					var liaison = liste[i];
					liaisons = liaisons.concat("<dd>Reseau " + " : " + liaison.name + "</dd>");
					for (var j = 0; j < liaison.lignes.length; j++) {
						var ligne = liaison.lignes[j];
						liaisons = liaisons.concat("<ul><li>Ligne " + ligne.number + " : " + ligne.name + "</li></ul>");
					}
				}
				liaisons.concat("</dt>");
			} else {
				liaisons += "<br>- Aucune liaison de ligne -";
			}
			var parsedTemplate = "<div class='olPopup'>" +
				"<br>Point d'arrêt: " + feature.attributes.point.name +
				"<br>Nom commercial : " + feature.attributes.point.commercial_name +
				// "<br>Sens : " + feature.attributes.point.way +
				liaisons +
				"</div>";
			return parsedTemplate;
		}

		/**
		 * Template for map marker's popups.
		 * @param feature feature properties to display.
		 * @returns {string}
		 */
		function popupRouteStopPointTemplate(feature) {
			var liste;
			if(feature.attributes === undefined){
				liste = feature.liaisons;
			}
			else{
				liste = feature.attributes.point.liaisons;
			}
			var liaisons = "";
			if(liste === null) {
				liaisons += "<br>- Aucune liaison de ligne -";
			}
			else if (liste.length === 0) {
				liaisons += "<br>Liaisons : <img style='height: 15px' src=\"../../assets/img/loading-orange.svg\"/><dt>";
			}
			else if(liste.length > 0){
				liaisons += "<br>Liaisons : <dt>";
				for (var i = 0; i < liste.length; i++) {
					var liaison = liste[i];
					liaisons = liaisons.concat("<dd>Reseau " + " : " + liaison.name + "</dd>");
					for (var j = 0; j < liaison.lignes.length; j++) {
						var ligne = liaison.lignes[j];
						liaisons = liaisons.concat("<ul><li>Ligne " + ligne.number + " : " + ligne.name + "</li></ul>");
					}
				}
				liaisons.concat("</dt>");
			}


			if(feature.attributes === undefined){
				var parsedTemplate = "<div class='olPopup'>" +
					"<br>Point d'arrêt: <b>" + feature.name + "</b>" +
					"<br>Nom commercial : " + feature.commercial_name +
					// "<br>Sens : " + feature.attributes.point.way +
					liaisons +
					"</div>";
				return parsedTemplate;
			}
			else{
				var parsedTemplate = "<div class='olPopup'>" +
					"<br>Point d'arrêt: <b>" + feature.attributes.point.name + "</b>" +
					"<br>Nom commercial : " + feature.attributes.point.commercial_name +
					// "<br>Sens : " + feature.attributes.point.way +
					liaisons +
					"</div>";
				return parsedTemplate;
			}
		}


		function preparePointsStyle(points, point, options, index) {
			var styleDef;
			if (point.style) {
				styleDef = point.style;
			}
			else {
				styleDef = angular.copy(defaultMarkerStyle);
			}
			if (options.showStartAndEndPoints) {
				if (index === 0) {
					styleDef.externalGraphic = CONSTANTS.MAP_MARKER_START;
				} else if (index === points.length - 1) {
					styleDef.externalGraphic = CONSTANTS.MAP_MARKER_END;
				} else {
					styleDef.externalGraphic = CONSTANTS.MAP_MARKER_DEFAULT;
				}
			}
			return styleDef;
		}


		/**
		 * Template for map marker's popups.
		 * @param feature feature properties to display.
		 * @returns {string}
		 */
		function popupPointsStopPointTemplate(feature) {
			var template = popupRouteStopPointTemplate(feature);
			// var buttonTemplate = '<a href="#/e-iti/arrets/' + feature.attributes.point.id + '"><button class="btn btn-primary"><span class="fa fa-pencil-alt"></span> </button></a>';
			// template = buttonTemplate + template;
			return template;
		}

		/**
		 * Retrieve an existing layer in the map, or create it if not existing.
		 * The layer is created with some basics click events displaying popups.
		 *
		 * @param map
		 * @param layerName
		 * @returns {*}
		 */
		function findOrCreateLayer(map, layerName, popupTemplate, customStyle) {
			// is Layer already existing ?
			var layer;
			var layersFound = map.getLayersByName(layerName);

			if (layersFound.length) {
				// layer already exists => make sure it is shown
				layer = layersFound[0];
				layer.setVisibility(true);
			} else {

				var style = {
					externalGraphic: "assets/img/map_icons/marker.png",
					graphicWidth: 20, graphicHeight: 24,
					pointRadius: 3,
					cursor: "pointer",
					graphicYOffset: -24
				};

				if (customStyle) {
					style = customStyle;
				}

				// layer does not exist => create and populate it
				if (popupTemplate) {
					layer = new OpenLayers.Layer.Vector(layerName, {
						style: style,
						eventListeners: {
							// on marker's click
							"featureselected": function (evt) {
								var feature = evt.feature;

								if (feature.attributes.point) {
									var popup = new OpenLayers.Popup.FramedCloud("popup",
										OpenLayers.LonLat.fromString(feature.geometry.toShortString()),
										null,
										popupTemplate ? popupTemplate(feature).toString() : popupCreateRouteTemplate(feature).toString(),
										null,
										true
									);
									feature.popup = popup;
									map.addPopup(popup);
									popup.panIntoView();
								}
							},

							// clicking outside the popup
							"featureunselected": function (evt) {
								var feature = evt.feature;
								if (feature.popup) {
									map.removePopup(feature.popup);
									feature.popup.destroy();
									feature.popup = null;
								}
							}
						}
					});
				} else {
					layer = new OpenLayers.Layer.Vector(layerName, {style: style});
				}
				map.addLayer(layer);

				var selector = new OpenLayers.Control.SelectFeature([layer], {
					autoActivate: true,
					clickout: true, toggle: true,
					multiple: false, hover: false
				});
				map.addControl(selector);
				selector.activate();
			}
			return layer;
		}

		/**
		 * Takes an array of two coordinates (longitude / latitude). Builds a new OL Point object with it, and transform geometry.
		 * @param coordinates ["longitude"; "latitude"]
		 * @returns {*}
		 */
		function transformGeometryAndCreateOlPoint(coordinates) {
			return new OpenLayers.Geometry.Point(coordinates[0], coordinates[1]).transform(CONSTANTS.MAP_FROM_PROJECTION, CONSTANTS.MAP_TO_PROJECTION);
		}


		function radians(n) {
			return n * (Math.PI / 180);
		}

		function degrees(n) {
			return n * (180 / Math.PI);
		}


	}


	])


;


